import { ApolloClient } from '@apollo/client';
import { GET_INGREDIENTS_TO_AVOID } from 'src/graphql-operations/catalog-service/catalogs.query';
import {
  IngredientsToAvoidQuery,
  IngredientsToAvoidQueryVariables,
} from 'src/ts/@types/generated/graphql/catalog-service/graphql';
import { ClientNames } from 'src/utils/apolloClient';

export const getIngredientsToAvoid = async (input: {
  apolloClient: ApolloClient;
}): Promise<IngredientsToAvoidQuery['ingredientsToAvoid']> => {
  const { apolloClient } = input;

  const { data } = await apolloClient.query<
    IngredientsToAvoidQuery,
    IngredientsToAvoidQueryVariables
  >({
    query: GET_INGREDIENTS_TO_AVOID,
    context: { clientName: ClientNames.CATALOG_SERVICE_GRAPH },
  });

  return data?.ingredientsToAvoid ?? [];
};
